import React, { Component } from 'react';
import './App.css';
import VideoHeadApp from '../video-head-app/video-head-app';
import List from '../list';
import SearchPanel from '../search-panel';
/*import banner from "../img/banner.png";*/
import FormSend from '../form-send';
import ScrollUp from '../ScrollUp/ScrollUp';

export default class App extends Component {
  state = {
    term: '',
    companyObjectList: [
      {
        id: 1,
        company: 'Кафе "Veranda"',
        address:
          'Обращаться г.Гулькевичи, ул. Красная, 13 (здание Дома торговли)',
        job: [
          {
            title: 'Бармен',
            description:
              '(з/п 1000руб смена, график работы 2/2 с 11.00 до 23.00) Внутрикорпаративное обучение и развитие, курс стажировки. Бесплатное двухразовое питание. Обязанности: приготовление напитков и кофе. Закрытие и учет кассовой смены. з/п 1000руб смена, график работы 2/2 с 11.00 до 23.00) Внутрикорпаративное обучение и развитие, курс стажировки. Бесплатное двухразовое питание. Обязанности: приготовление напитков и кофе. Закрытие и учет кассовой смены',
          },
          {
            title: 'Официант',
            description:
              '(з/п 1000руб смена, график работы 2/2 с 11.00 до 23.00) Предоставляем бесплатное питание для сотрудников.Обучаем работе в заведении. Обязанности: работа в команде, работа с гостями. Требования: Знание меню. Быть опрятным и приветливым',
          },
          {
            title: 'Повар',
            description:
              '(з/п от 1200 до 2000руб смена, сменный график работы с 11.00 до 23.00). Внутрикорпаративное обучение и развитие, курс стажировки. (стажировка оплачивается). Опыт в качестве повара является преимуществом и поощряется размером з/п',
          },
        ],
      },
      {
        id: 2,
        company: 'АО "Блок"',
        address:
          'Оформление согласно ТК РФ, корпоративный транспорт до предприятия, горячее питание ПРЕДОСТАВЛЯЕТСЯ БЕСПЛАТНО, полный соцпакет. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Формовщики железобетонных изделий и конструкций',
            description: 'з/п от 50000руб.',
          },
          {
            title: 'Водитель категории С, Е',
            description: 'з/п от 45000руб.',
          },
          {
            title: 'Токарь',
            description: '',
          },
          {
            title: 'Слесарь - ремонтник',
            description: '',
          },
          {
            title: 'Арматурщик',
            description: 'з/п от 50000руб.',
          },
          {
            title: 'Электрогазосварщик от 4 разряда',
            description: 'з/п от 45000руб.',
          },
          {
            title: 'Водитель фронтального погрузчика',
            description: 'з/п от 45000руб.',
          },
        ],
      },
      {
        id: 3,
        company: 'ООО ДСОК "Жемчужина"',
        address:
          'Фактический адрес организации: Анапа, Пионерский проспект, 253. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Официант',
            description:
              '(з/п от 1500 руб. + премия) Предварительно накрывать и сервировать столы на основании меню. Убирать использованную посуду, приборы после приёма пищи. Своевременно производить замену столового белья (скатерти, салфетки) при их загрязнении. Содержать в чистоте рабочее место и форменную одежду.',
          },
          {
            title: 'Уборщик служебных помещений',
            description:
              '(з/п от 1500 руб. + премия) Уборка производительных и вспомогательных помещений от отходов производства и мусора. Вытирание пыли, подметание и мойка вручную или с помощью машин и приспособлений полов, лестниц, лестничных клеток, окон, стен, потолков, оконных рам и стёкол, дверных блоков, мебели. Приготовление различных моющих и дезинфицирующих растворов для мойки: полов, стен, окон и потолков Получение моющих средств, инвентаря и обтирочного материала Транспортирование отходов и мусора производственных и вспомогательных помещений в места для сбора мусора. Расстановка урн для мусора.',
          },
          {
            title: 'Повар-универсал',
            description:
              '(з/п от 2000 руб. + премия) Осуществляет приготовление блюд и кулинарных изделий, требующих кулинарной обработки средней сложности: салаты из свежих, варёных и припущенных овощей, с мясом, рыбой; винегреты; рыбы под маринадом; сельдь натуральную и с гарниром; студень. Производит варку бульонов, супов. Приготавливает вторые блюда из овощей, рыбы и морепродуктов, мяса и мясных продуктов, сельскохозяйственной птицы и кролика в варёном, тушёном и запечённом виде; соусы, различных видов пассировки; горячие и холодные напитки; сладкие блюда, мучные изделия: варёнки, пельмени, расстегаи, кулебяки, пирожки, лапшу домашнюю, ватрушки.',
          },
          {
            title: 'Мойщик посуды',
            description:
              '(з/п от 1500 руб. + премия) Осуществлять мытье столовой и кухонной посуды, приборов, подносов, инвентаря, инструмента, тары вручную и на посудомоечной машине с применением моющих и дезинфицирующих средств; раскладывать на сушку и хранение столовую посуду и приборы, кухонную посуду, инвентарь, инструменты. Выполнять подготовительные работы при мытье посуды. Производить очистку посуды, приборов, подносов, инвентаря и инструментов от остатков пищи. Сортировать отходы (отдельно бумага, стекло, металл, пластик, пищевые отходы) и транспортировать их в установленное место. Приготавливать моющие и дезинфицирующие растворы соблюдая их концентрацию. Производить санитарную обработку посудомоечной машины и ванн для мытья посуды, содержать их в чистоте и исправном состоянии.',
          },
        ],
      },
      {
        id: 4,
        company: 'МП "Водоканал г. Гулькевичи"',
        address: 'За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Водитель 4 разряда',
            description: '',
          },
          {
            title: 'Слесарь аварийно - восстановительных работ',
            description: '',
          },
          {
            title: 'Механик в цех водозапорных сооружений',
            description: '',
          },
          {
            title:
              'Электромонтер по ремонту и обслуживанию электрооборудования',
            description: '',
          },
        ],
      },
      {
        id: 5,
        company: '"ОАО АПСК" "Гулькевичский"',
        address: 'За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Формовщик изделий, конструкций и строительных материалов',
            description: '',
          },
          {
            title: 'Отделочник железобетонных изделий 3 разряда',
            description: '',
          },
          {
            title: 'Сварщик арматурных сеток и каркасов 3 разряда',
            description: '',
          },
          {
            title: 'Контролер ОТК',
            description: '',
          },
          {
            title: 'Слесарь-ремонтник',
            description: '',
          },
        ],
      },
      {
        id: 6,
        company: '"МУП БГП БР "Белореченские тепловые сети"',
        address:
          'В настоящее время проводится набор персонала на должность слесарь КИПиА. Сфера деятельности предприятия: Теплоснабжение, Должность обязанности: обслуживание и ремонт приборов КИПиА котельных и ЦТП. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Слесарь КИПиА',
            description:
              'Пятидневная рабочая неделя продолжительностью 40 часов, выходные дни суббота и воскресенье. Режим работы: полный рабочий день. Заработная плата: от 21000 руб. до 29700 руб. Соц. пакет: обязательное социальное страхование в соответствии с законодательством РФ',
          },
        ],
      },
      {
        id: 7,
        company: 'ООО "МПП Южное"',
        address:
          'Обращаться по адресу: г.Гулькевичи, тер.Промзона 1Г(напротив СКЗСК). За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title:
              'Электромонтер по ремонту и обслуживанию электрооборудования',
            description:
              'Рассмотрим кандидатов без опыта работы(выпускников с начальным профессиональным,средне-техническим образованием). Обязанности: Ремонт и обслуживание электрооборудования предприятия. Выполнение электромонтажных работ. График работы: 5/2. Заработная плата от 25 тыс.руб. Бесплатное горячее питание.',
          },
        ],
      },
      {
        id: 8,
        company: 'Группа компаний ОТЭКО',
        address:
          'Реализует комплексную инвестиционную программу по строительству морской портовой и промышленной структуры на Таманском полуострове. В связи с чем осуществляется подбор кадров по вакансиям. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Слесарь-ремонтник 4,5,6 разрядов',
            description: 'Возможно без опыта работы.',
          },
          {
            title:
              'Электромонтер по ремонту и обслуживанию электрооборудования 4,5,6 разрядов',
            description: 'Возможно без опыта работы.',
          },
          {
            title:
              'Электромонтер по ремонту и обслуживанию электрооборудования(дежурный)',
            description: 'Возможно без опыта работы.',
          },
          {
            title: 'Электромонтер по испытаниям и измерениям 4,5 разряда',
            description: 'Возможно без опыта работы.',
          },
          {
            title: 'Машинист насосных установок',
            description: 'Возможно без опыта работы.',
          },
          {
            title:
              'Слесарь по контрольно-измерительным приборам и автоматике 4,5,6 разрядов',
            description: 'Возможно без опыта работы.',
          },
          {
            title: 'Кладовщик',
            description: 'Опыт работы на складе, знание ПК.',
          },
        ],
      },
      {
        id: 9,
        company: 'ООО Агрофирма "Тысячный"',
        address:
          'Россия, Краснодарский край, Гулькевичский район, х. Тысячный. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Электрогазосварщик',
            description: 'Растениеводческий отряд: электрогазосварщик — 1 чел.',
          },
          {
            title: 'Слесарь по жив. оборудованию ',
            description: 'МТФ №3: слесарь по жив оборудованию — 1 чел.',
          },
          {
            title: 'Каменщик плотник',
            description: 'Бригада трудоемких процессов: 1 чел.',
          },
          {
            title: 'Слесарь-ремонтник',
            description: 'Бригада трудоемких процессов: 3 чел.',
          },
          {
            title: 'Штукатур-маляр',
            description: 'Бригада трудоемких процессов: 3 чел.',
          },
          {
            title: 'Электрогазосварщик ',
            description: 'Бригада трудоемких процессов: 1 чел.',
          },
        ],
      },
      {
        id: 10,
        company: 'АО "Племзавод Гулькевичский"',
        address:
          'Россия, Краснодарский край, Гулькевичский район, г.Гулькевичи. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Слесарь-ремонтник 5 разряда',
            description:
              'Центральный технический комплекс: (квота для инвалида) — 1 чел.',
          },
          {
            title: 'Моторист 5 разряда',
            description: 'Центральный технический комплекс:  1 чел.',
          },
          {
            title: 'Каменщик 4 разряда ',
            description: 'Стройцех: 1 чел.',
          },
        ],
      },
      {
        id: 11,
        company: 'ПАО "ОДК-Сатурн"',
        address:
          'Россия, г.Рыбинск. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Автоматчик',
            description:
              '3-4 разряд, многосменный режим работы, З/П до 50000руб. — 7 чел.',
          },
          {
            title: 'Администратор вычислительной сети',
            description:
              '4-6 разряд, односменный режим работы, З/П до 63100руб. — 2 чел.',
          },
          {
            title: 'Слесарь по сборке металлоконструкций',
            description:
              '3-6 разряд, односменный режим работы, З/П до 50000руб. — 5 чел.',
          },
          {
            title: 'Слесарь-инструментальщик',
            description:
              '3-6 разряд, многосменный режим работы, З/П до 50000руб. — 6 чел.',
          },
          {
            title: 'Слесарь-ремонтник',
            description:
              '3-6 разряд, многосменный режим работы, З/П до 75000руб. — 13 чел.',
          },
          {
            title: 'Электрогазосварщик',
            description:
              '3-6 разряд, многосменный режим работы, З/П до 80000руб. — 3 чел.',
          },
          {
            title: 'Элетромонтер по обслуживанию',
            description:
              '3-6 разряд, многосменный режим работы, З/П до 50000руб. — 2 чел.',
          },
          {
            title: 'Слесарь',
            description:
              'Слесарь по изготовлению деталей и узлов систем вентиляции, кондиционирования воздуха, пневмотранспорта и аспирации, 6 разряд, односменный режим работы, З/П до 70000руб. — 1 чел.',
          },
          {
            title: 'Маляр',
            description:
              '3-4 разряд, многосменный режим работы, З/П до 40000руб. — 1 чел.',
          },
          {
            title: 'Наладчик КИПиА',
            description:
              '4-6 разряд, многосменный режим работы, З/П до 80000руб. — 9 чел.',
          },
        ],
      },
      {
        id: 12,
        company: 'Гостиничный комплекс Имеретинский',
        address:
          'Филиал ООО РогСибАл Россия, г.Сочи. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Маляр-штукатур',
            description: `
                        Обязанности:
                        Внутренняя отделка помещений;
                        Изготовление строительных растворов из соответствующих строительных смесей и материалов;
                        Штукатурка, шпатлёвка, шлифовка и грунтовка стен, потолков, откосов окон и дверей;
                        Покраска стен, потолков;

                        Требования:
                        Опыт работы в аналогичной должности;
                        Знание технологий малярных, штукатурных работ;

                        Мы предлагаем:
                        Официальное оформление по ТК РФ (выплаты з/п два раза в месяц), оклад 55200 руб.;
                        График работы 5/2 пн-пт с 09:00 до 18:00;
                        Служебное питание в рабочие смены;
                        Бесплатное комфортное проживание на территории отеля;
                        Работа в Отеле уровня 4* и широкие возможности для профессионального и карьерного роста.
                        Место работы - район Олимпийского парка (Адлерский район).
                        `,
          },
        ],
      },
      {
        id: 13,
        company: 'ООО "ДАН-БЕТОН ПЛЮС"',
        address:
          'г.Гулькевичи. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Сварщик на машинах контактной сварки',
            description: `Полный соц. пакет, З/П от 25000 руб.,
                          Приглашаем выпускников и учащихся (в переиод каникул).
                       `,
          },
        ],
      },
      {
        id: 14,
        company: 'АО "Нафтатранс"',
        address:
          'Краснодарский филиал АО "Нафтатранс, Кавказсий район, ст. Кавказская. За дополнительной информацией обращаться в ИЦ ГСТ',
        job: [
          {
            title: 'Элетромонтер по ремонту и обслуживанию электрооборудования',
            description: `Возраст от 18 лет. Полный соц. пакет, З/П от 25000 - 53000руб. + премии,
                          Приглашаем выпускников и учащихся (стажировка, трудоустройство).
                       `,
          },
          {
            title: 'Слесарь КИПиА',
            description: `Возраст от 18 лет. Полный соц. пакет, З/П от 25000 - 53000руб. + премии,
                          Приглашаем выпускников и учащихся (стажировка, трудоустройство).
                       `,
          },
        ],
      },
    ],
  };

  onSearchChange = (term) => {
    this.setState({ term });
  };

  render() {
    let date = new Date();
    let output = date.getFullYear();

    return (
      <div>
        <div className='container-fluid'>
          <div className='row' id='start'>
            <VideoHeadApp />
            <ScrollUp />
            <div className='cont-app' id='cont-app'>
              <SearchPanel onSearchChange={this.onSearchChange} />
              <List
                companyObjectList={this.state.companyObjectList}
                term={this.state.term}
              />
            </div>

            <FormSend />
            <div className='footer'>
              <p
                className='cont-app'
                style={{ color: '#fff', fontSize: '15px' }}
              >
                &copy; 2021 - {output} | ГБПОУ КК Гулькевичский строительный
                техникум | (+7-861-60)-3-44-21)
                <br />
                <i className='fa fa-map-marker' aria-hidden='true'></i> 352190,
                Краснодарский край, г.Гулькевичи, ул.Советская, 41{' '}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
